const sleep = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

function displayStatus(target, message, focus = false) {
  target.textContent = message;
  target.classList.add('is-visible');
  if (focus) target.focus();
}

async function readPayload(response, fallbackMessage) {
  try {
    return await response.json();
  } catch (_error) {
    throw new Error(fallbackMessage);
  }
}

function responseError(payload, messages, fallbackMessage) {
  if (payload.error_code === 'file_size_exceeded') return messages.too_large;
  return payload.errors?.[0]?.message || payload.message || fallbackMessage;
}

async function pollStatus(form, statusTarget, importId, messages) {
  const url = form.dataset.statusUrl.replace('__IMPORT_ID__', encodeURIComponent(importId));
  let lastStatus = null;
  for (let attempt = 0; attempt < 90; attempt += 1) {
    await sleep(2000);
    const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    const payload = await readPayload(response, messages.status_error);
    if (!response.ok) throw new Error(responseError(payload, messages, messages.status_error));
    if (payload.status === 'draft') return displayStatus(statusTarget, messages.finished);
    if (payload.status === 'failed') {
      const reason = payload.errors?.[0]?.message || payload.status;
      return displayStatus(statusTarget, messages.failed.replace('%{reason}', reason));
    }
    if (payload.status === 'expired') return displayStatus(statusTarget, messages.expired);
    if (payload.status !== lastStatus) {
      displayStatus(statusTarget, messages.statuses[payload.status] || messages.unknown_status);
      lastStatus = payload.status;
    }
  }
  displayStatus(statusTarget, messages.follow_up);
}

export function initSongolinoAdminImport() {
  const panels = document.querySelectorAll('[data-import-panel]');
  document.querySelectorAll('[data-import-mode]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-import-mode]').forEach((choice) => {
        const selected = choice === button;
        choice.classList.toggle('is-active', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
      panels.forEach((panel) => panel.classList.toggle('is-hidden', panel.dataset.importPanel !== button.dataset.importMode));
    });
  });

  document.querySelectorAll('[data-songolino-form]').forEach((form) => {
    const statusTarget = form.querySelector('[data-import-status]');
    const messages = JSON.parse(form.dataset.importMessages);
    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="file"]')) {
        const packageId = form.querySelector('[name="package_id"]');
        if (packageId) packageId.value = crypto.randomUUID();
      }
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      displayStatus(statusTarget, messages.uploading, true);
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        const payload = await readPayload(response, messages.rejected);
        if (!response.ok) throw new Error(responseError(payload, messages, messages.rejected));
        await pollStatus(form, statusTarget, payload.import_id, messages);
      } catch (error) {
        displayStatus(statusTarget, error.message || messages.rejected);
      } finally {
        button.disabled = false;
      }
    });
  });
}
